module.exports = __webpack_public_path__ + "static/media/thumbs-up.75750b51.png";